import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../views/Layout/index.vue'
import HomeView from '../views/HomeView/index.vue'
import SearchView from '../views/SearchView/index.vue'
import Offer from '../views/OfferView/index.vue'
import HelpCenterView from '../views/HelpCenterView/index.vue'
import GuideView from '../views/GuideView/index.vue'
import Carts from '../views/Carts/index.vue'
import Orders from '../views/Orders/index.vue'
import Account from '../views/Account/index.vue'
import OrderFilling from '../views/OrderFilling/index.vue'
import BankPayment from '../views/BankPayment/index.vue'
import FeaturedView from '@/views/Featured/index.vue'
import { setThemeColor, buriedPointUtil, gaAnalytics } from '@/utils/utils'
import store from '@/store/index.js'
import { useUserStore } from '@/pinia/user'

const isMobile = store.state.isMobile === 'MOBILE'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          name: 'home',
          component: HomeView
        },
        {
          path: '/search',
          name: 'search',
          component: isMobile ? HomeView : SearchView
        },
        {
          path: '/featured/:category/:collectionId?',
          name: 'featured',
          component: FeaturedView
        },
        {
          path: 'offer/:id',
          name: 'offer',
          component: Offer
        },
        {
          path: '/help',
          name: 'help',
          component: HelpCenterView
        },
        {
          path: '/guide',
          name: 'guide',
          component: GuideView
        },
        {
          path: '/carts',
          name: 'carts',
          component: Carts,
          meta: {
            auth: true
          }
        },
        {
          path: '/orders',
          name: 'orders',
          component: Orders,
          meta: {
            auth: true
          }
        },
        {
          path: '/account',
          name: 'account',
          component: Account,
          meta: {
            auth: true
          }
        },
        {
          path: '/orderFilling',
          name: 'orderFilling',
          component: OrderFilling,
          meta: {
            auth: true
          }
        },
        {
          path: '/bankPayment/:orderNo',
          name: 'bankPayment',
          component: BankPayment,
          meta: {
            auth: true
          }
        },
        {
          path: '/notSupport',
          name: 'notSupport',
          component: () => import('../views/NotSupport/index.vue')
        }
      ]
    }, {
      path: '/:pathMatch(.*)*',
      redirect: {
        name: 'home'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isMobile = store.state.isMobile === 'MOBILE'
  const { tk, uid } = useUserStore().userInfo

  const isLogin = tk != null

  if (isMobile) {
    buriedPointUtil({ eventId: 'MPWH101' })
    gaAnalytics('mp_page_view', 'mp_page_view', {
      bdUserId: uid
    })
    if (to.path === '/search') {
      buriedPointUtil({ eventId: 'MPSC101' })
    }
    if (to.path === '/' && store.state.productList.length === 0) {
      store.dispatch('initHomeData', {
        adsWord: to.query.data
      })
    }

    if (to.path.includes('/orders') || to.path.includes('/carts') || to.path.includes('account') || to.path.includes('/orderFilling')) {
      setThemeColor('#141414')
    } else {
      setThemeColor('#052785')
    }
  }

  if (!isLogin) {
    if (to.meta.auth) {
      const utmParams = Object.keys(from.query).filter(key => key.startsWith('utm_') || key === 'source')
      next({
        name: 'guide',
        query: utmParams.reduce((params, cur) => ({ ...params, [cur]: from.query[cur] }), {})
      })
      return
    }

    /**
     * 当路径是 guide 时，保存之前的路由链接，在登录完成后跳转回原路由
     */
    if (to.name === 'guide') {
      /**
       * 避免出现多个异步接口触发 401 导致 guide 页 fallback 被覆盖问题
       */
      if (from.name === 'guide') return

      if (to.query.fallback) {
        next()
        return
      }
      const _from = to.redirectedFrom ?? from
      next({
        name: 'guide',
        params: _from.params,
        query: {
          ..._from.query,
          ...to.query,
          fallback: _from.path ?? '/'
        }
      })
      return
    }
  } else {
    if (to.name === 'guide' && to.query.sp !== '1') {
      next('/')
      return
    }
  }

  next()
})

export default router
